import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';

import NextLink from '../nextLink';

interface HeaderIconProps {
  link?: string;
  icon?: ReactNode;
  onClick?: () => void;
  isUserIcon?: boolean;
  isMenuIcon?: boolean;
  isLogged?: boolean;
  numOfNotification?: number;
  hasMessageNotification?: boolean;
}

const HeaderIcon: FC<HeaderIconProps> = ({
  link,
  icon,
  isLogged = false,
  numOfNotification = 0,
  // isUserIcon = false,
  isMenuIcon = false,
  hasMessageNotification = false,
  onClick,
}) => {
  const plusNotification = numOfNotification && numOfNotification > 99;

  const className = {
    containerClass: clsx(
      'flex h-full justify-center m-0 relative sm:w-1/2 md:w-1/3'
    ),
    linkClass:
      'border-b-7px border-transparent flex items-center p-0 sm:ml-0 md:ml-auto hover:border-b-7px hover:border-green70 wl-border-highlight--hover',
    notificationClass: clsx(
      '!leading-5 absolute bg-red60 rounded-circle text-[12px] text-center text-white wl-bg-highlight wl-text-highlight',
      isLogged
        ? 'h-10px w-10px sm:right-[4px] md:-right-[11px] lg:top-[12px] top-[12px] md:top-[18px]'
        : 'h-20px sm:right-[4px] md:-right-[11px] w-20px lg:top-[10px] top-[6px] md:top-[12px]'
    ),
    buttonContainerClass: clsx(
      '-mb-7px border-b-7px flex h-[calc(100%-7px)] relative lg:hidden hover:border-b-7px',
      'border-transparent monochrome:hover:border-grey90 hover:border-green70',
      'wl-border-highlight--hover'
    ),
    buttonClass: 'flex items-center p-0',
  };
  if (isMenuIcon) {
    return (
      <div className={className.buttonContainerClass}>
        <button
          type="button"
          className={className.buttonClass}
          onClick={onClick}
        >
          {icon}
          {isLogged && hasMessageNotification && (
            <span className={className.notificationClass}></span>
          )}
        </button>
      </div>
    );
  } else {
    return (
      <div className={className.containerClass}>
        {link && (
          <NextLink href={link} passHref={true} className={className.linkClass}>
            {icon}
            {(numOfNotification || isLogged) && (
              <span className={className.notificationClass}>
                {plusNotification
                  ? '99'
                  : !!numOfNotification && numOfNotification}
              </span>
            )}
          </NextLink>
        )}
      </div>
    );
  }
};

export default HeaderIcon;
